import React, { useEffect, useRef, useState } from "react";
import { update_page_meta } from "../../actions/page/header";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import axios from "axios";
import { JSON_CONTENT_FORM_CONFIG } from "../../actions/Config";
import PageHeader from "../../components/page/PageHeader";
import { HomePageURL } from "../../assets/const";
import { validateCodeRegex } from "../../utils/validateCode";
import { getJSONContentFormConfig } from "../../actions/Config";

const MoveDetail = ({ update_page_meta }) => {
  const [transfer, setTransfer] = useState(null);
  const { moveID } = useParams();
  const [qrCode, setQrCode] = useState("");
  const [products, setProducts] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [fetching, setFetching] = useState(false);
  const bottomElementRef = useRef();
  useEffect(() => {
    const fetchMore = async () => {
      if (page > totalPages || fetching) return;
      try {
        setFetching(true);
        let params = `page=${page}&page_size=${pageSize}&move_id=${moveID}`;
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/stock/fetch-transfer-lines/?${params}`,
          JSON_CONTENT_FORM_CONFIG
        );
        if (response.status === 200) {
          setProducts((prevItems) => {
            if (page === 1) {
              return response.data.results; // Set the initial orders
            } else {
              return [...prevItems, ...response.data.results]; // Append new orders
            }
          });
          setTotalPages(response.data.num_pages);
          setPage(page + 1);
        }
      } catch (error) {
        console.error("Error fetching more products:", error);
      } finally {
        setFetching(false);
      }
    };
    const options = {
      root: null, // viewport
      rootMargin: "0px",
      threshold: 0.1, // When 10% of the element is visible, trigger the callback
    };

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        fetchMore();
      }
    }, options);

    const bottomElement = bottomElementRef.current;

    if (bottomElement) {
      observer.observe(bottomElement);
    }

    return () => {
      if (bottomElement) {
        observer.unobserve(bottomElement);
      }
    };
  }, [bottomElementRef, page, totalPages, fetching]);
  useEffect(() => {
    const fetchTransfer = async () => {
      try {
        let params = `move_id=${moveID}`;
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/stock/fetch-single-transfer/?${params}`,
          JSON_CONTENT_FORM_CONFIG
        );
        if (res.status === 200) {
          setTransfer(res.data);
        }
      } catch {}
    };
    fetchTransfer();
  }, [moveID]);
  const created_at = new Date(transfer?.created_at);
  update_page_meta({
    title: `Transfer started on ${created_at.getDate()}-${
      created_at.getMonth() + 1
    }-${created_at.getFullYear()} ${created_at.getHours()}:${created_at.getMinutes()}`,
    description: `Transfer started on ${created_at.getDate()}-${
      created_at.getMonth() + 1
    }-${created_at.getFullYear()} ${created_at.getHours()}:${created_at.getMinutes()}`,
  });
  const addProduct = async () => {
    try {
      let data = {
        move_id: moveID,
        product_code: qrCode,
      };
      const jsonConfig = getJSONContentFormConfig();
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/stock/add-product-to-transfer/`,
        JSON.stringify(data),
        jsonConfig
      );
      if (res.status === 200) {
        setProducts((prevItems) => [res.data, ...prevItems]);
      }
    } catch (err) {
      window.alert(err?.response?.data?.error || "An error occurred");
    }
    setQrCode("");
    qrCodeInputRef.current.focus();
  };
  const addBundle = async () => {
    try {
      let data = {
        move_id: moveID,
        bundle_code: qrCode,
      };
      const jsonConfig = getJSONContentFormConfig();
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/stock/add-bundled-products-to-transfer/`,
        JSON.stringify(data),
        jsonConfig
      );
      if (res.status === 200 && Array.isArray(res.data)) {
        // Assuming res.data is an array of products
        setProducts((prevItems) => [...res.data, ...prevItems]);
      } else {
        window.alert("Unexpected response format");
      }
    } catch (err) {
      window.alert(err?.response?.data?.error || "An error occurred");
    }
    setQrCode("");
    qrCodeInputRef.current.focus();
  };
  const qrCodeReadHandler = (e) => {
    let el = e.currentTarget;
    let val = el.value;
    setQrCode(val);
  };
  const qrCodeInputRef = useRef();
  const onKeyUp = (e) => {
    if (e.keyCode === 13) {
      const trimmedCode = qrCode.trim();

      if (!validateCodeRegex(trimmedCode)) {
        window.alert("Invalid code. Please try again");
        setQrCode("");
        qrCodeInputRef.current.focus();
        return;
      }

      if (trimmedCode.startsWith("bdl_") && trimmedCode.length === 36) {
        addBundle();
      } else {
        addProduct();
      }
    }
  };

  const [validating, setValidating] = useState(false);
  const validate = async () => {
    if (products.length === 0) {
      window.alert("There are no products to transfer");
      return;
    }
    if (
      !window.confirm(
        "This will validate all products in this transfer. This cannot be reversed. Are you sure?"
      )
    )
      return;
    try {
      setValidating(true);
      let data = {
        move_id: moveID,
      };
      const jsonConfig = getJSONContentFormConfig();
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/stock/validate-stock-transfer/`,
        JSON.stringify(data),
        jsonConfig
      );
      if (res.status === 200) {
        setTransfer({ ...transfer, status: "Complete" });
      }
    } catch (err) {
      window.alert(err?.response?.data?.error || "An error occurred");
    }
    setValidating(false);
  };

  return (
    <>
      <PageHeader
        title={`Transfer started on ${created_at.getDate()}-${
          created_at.getMonth() + 1
        }-${created_at.getFullYear()} ${created_at.getHours()}:${created_at.getMinutes()}`}
      />
      {/* {transfer?.status && transfer?.status !== 'Incomplete' &&
        <div className='' style={{position: "absolute", top: 0, right: 0, padding: "15px 7px", transform: "rotate(45deg)", background: "blue"}}>
            <p>{transfer?.status}</p>
        </div>
        } */}
      <div className="row layout-top-spacing" id="cancel-row">
        {transfer?.status === "Incomplete" && (
          <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
            <button
              className="btn btn-primary"
              disabled={validating}
              onClick={validate}
            >
              Validate
            </button>
            {/* <button className="btn btn-danger ms-3">Cancel Transfer</button> */}
          </div>
        )}
        <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
          <div className="widget-content widget-content-area br-6">
            <div className="row">
              <div className="col-md-6">
                <div
                  className="d-flex"
                  style={{ justifyContent: "flex-start" }}
                >
                  <span style={{ fontWeight: 600, flex: 0.3 }}>
                    Source Location
                  </span>
                  <span style={{ fontWeight: 600, flex: 0.7 }}>
                    {transfer?.source?.location_type === "Warehouse Location"
                      ? `Warehouse: ${transfer?.source?.warehouse?.name}`
                      : transfer?.source?.location_type}
                  </span>
                </div>
              </div>
              <div className="col-md-6">
                <div
                  className="d-flex"
                  style={{ justifyContent: "flex-start" }}
                >
                  <span style={{ fontWeight: 600, flex: 0.3 }}>
                    Destination Location
                  </span>
                  <span style={{ fontWeight: 600, flex: 0.7 }}>
                    {transfer?.destination?.location_type ===
                    "Warehouse Location"
                      ? `Warehouse: ${transfer?.destination?.warehouse?.name}`
                      : transfer?.destination?.location_type}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
          <div className="widget-content widget-content-area br-6">
            {transfer?.status === "Incomplete" && (
              <div className="form-group">
                <label>Read Product QR Code</label>
                <input
                  ref={qrCodeInputRef}
                  name="qrReader"
                  className="form-control"
                  placeholder="Read Product QR Code"
                  onKeyUp={onKeyUp}
                  onChange={qrCodeReadHandler}
                  value={qrCode}
                />
              </div>
            )}
            <div className="table-responsive mb-4 mt-4">
              <table className="table">
                <thead>
                  <th>Product Name</th>
                  <th>Manufactured On</th>
                  <th>Status</th>
                  <th className="no-content"></th>
                </thead>
                <tbody>
                  {products?.map((product) => {
                    return (
                      <tr key={product.id}>
                        <td>{product?.product?.product?.display_name}</td>
                        <td>{product?.product?.manufacturing_date}</td>
                        <td>{product?.status}</td>
                        <td className="no-content"></td>
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot ref={bottomElementRef}></tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { update_page_meta })(MoveDetail);
